import React from 'react'
import { useIntl } from 'react-intl'

import PriceLayout, { FeaturedPrice } from '../../../PriceLayout'
import type { OfferPriceProps } from '../types'

export interface IOfferPriceNetWithFeesProps extends OfferPriceProps {
  featuredPrice?: FeaturedPrice
}

const OfferPriceNetWithFees = ({
  className,
  board,
  nights,
  priceData,
  prime = false,
  showDiscount,
  showDiscountBadge,
  showFrom,
  showSubtitle,
  featuredPrice = FeaturedPrice.Total,
  loading = false,
}: IOfferPriceNetWithFeesProps) => {
  const intl = useIntl()

  const {
    currency,
    discount,
    initialPrice,
    subtotalWithFees,
    subtotalNightlyWithFees,
    taxDetails,
    additionalFees,
    insuranceSelected,
  } = board

  return (
    <PriceLayout
      className={className}
      currency={currency}
      discount={discount}
      pricePerNight={subtotalNightlyWithFees}
      priceInitial={initialPrice}
      priceFinal={subtotalWithFees}
      vats={intl.formatMessage({ id: 'global.includes-fees' })}
      priceData={priceData}
      prime={prime}
      showDiscount={showDiscount}
      showDiscountBadge={showDiscountBadge}
      showFrom={showFrom}
      nights={nights}
      featuredPrice={featuredPrice}
      loading={loading}
      showSubtitle={showSubtitle}
      taxDetails={taxDetails}
      additionalFees={additionalFees}
      insuranceSelected={insuranceSelected}
    />
  )
}

export default OfferPriceNetWithFees
